import { render, staticRenderFns } from "./TotalBoardHeader.vue?vue&type=template&id=3f3bc93f"
import script from "./TotalBoardHeader.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports